const baseUrl = "/assets/images/baybayin_guide_images/"

export const BaybayinGuideImages = {
  angonoPetroglyphs1: `${baseUrl}angono_petroglyphs_1.png`,
  angonoPetroglyphs2: `${baseUrl}angono_petroglyphs_2.png`,
  pamilangan: `${baseUrl}pamilangan.png`,
  pregnantWomanOfAngono: `${baseUrl}pregnant_woman_of_angono.png`,
  babaEiNana1: `${baseUrl}baba_ei_nana_1.png`,
  babaEiNana2: `${baseUrl}baba_ei_nana_2.png`,
  lagunaCopperplateInscription1: `${baseUrl}laguna_copperplate_inscription_1.png`,
  lagunaCopperplateInscription2: `${baseUrl}laguna_copperplate_inscription_2.png`,
  doctrinaChristiana: `${baseUrl}doctrina_christiana.png`,
  vocabularioDeLenguaTagala1: `${baseUrl}vocabulario_de_lengua_tagala_1.png`,
  vocabularioDeLenguaTagala2: `${baseUrl}vocabulario_de_lengua_tagala_2.png`,
  vocabularioDeLenguaTagala3: `${baseUrl}vocabulario_de_lengua_tagala_3.png`,
  vocabularioDeLenguaTagala4: `${baseUrl}vocabulario_de_lengua_tagala_4.png`,
  deedsOfSale1: `${baseUrl}deeds_of_sale_1.png`,
  deedsOfSale2: `${baseUrl}deeds_of_sale_2.png`,
  butuanMetalStrip1: `${baseUrl}butuan_metal_strip_1.png`,
  butuanMetalStrip2: `${baseUrl}butuan_metal_strip_2.png`,
  butuanMetalStrip3: `${baseUrl}butuan_metal_strip_3.png`,
  monrealStones: `${baseUrl}monreal_stones.png`,
  monrealStoneSideALine1: `${baseUrl}monreal_stone_side_A_line_1.png`,
  monrealStoneSideALine2: `${baseUrl}monreal_stone_side_A_line_2.png`,
  monrealStoneSideALine3: `${baseUrl}monreal_stone_side_A_line_3.png`,
  monrealStoneSideALine4: `${baseUrl}monreal_stone_side_A_line_4.png`,
  monrealStoneSideALine5: `${baseUrl}monreal_stone_side_A_line_5.png`,
  monrealStoneSideALine6: `${baseUrl}monreal_stone_side_A_line_6.png`,
  monrealStoneSideALine7: `${baseUrl}monreal_stone_side_A_line_7.png`,
  monrealStoneSideBLine1: `${baseUrl}monreal_stone_side_B_line_1.png`,
  monrealStoneSideBLine2: `${baseUrl}monreal_stone_side_B_line_2.png`,
  monrealStoneSideBLine3: `${baseUrl}monreal_stone_side_B_line_3.png`,
  monrealStoneSideBLine4: `${baseUrl}monreal_stone_side_B_line_4.png`,
  monrealStoneSideBLine5: `${baseUrl}monreal_stone_side_B_line_5.png`,
  monrealStoneSideBLine6: `${baseUrl}monreal_stone_side_B_line_6.png`,
  monrealStoneSideBLine7: `${baseUrl}monreal_stone_side_B_line_7.png`,
  monrealStoneSideBLine8: `${baseUrl}monreal_stone_side_B_line_8.png`,
  monrealStoneSideBLine9: `${baseUrl}monreal_stone_side_B_line_9.png`,
  birdClayFigurine1: `${baseUrl}bird_clay_figurine_1.png`,
  birdClayFigurine2: `${baseUrl}bird_clay_figurine_2.png`,
  birdClayFigurine3: `${baseUrl}bird_clay_figurine_3.png`,
  birdClayFigurine4: `${baseUrl}bird_clay_figurine_4.png`,
  hebrewLamp: `${baseUrl}hebrew_lamp.png`,
  pacalderoFonts: `${baseUrl}pacaldero_fonts.png`,
  calataganPot1: `${baseUrl}calatagan_pot_1.png`,
  calataganPot2: `${baseUrl}calatagan_pot_2.png`,
  calataganPot3: `${baseUrl}calatagan_pot_3.png`,
  calataganPot4: `${baseUrl}calatagan_pot_4.png`,
  calataganPot5: `${baseUrl}calatagan_pot_5.png`,
  calataganPot6: `${baseUrl}calatagan_pot_6.png`,
  calataganPot7: `${baseUrl}calatagan_pot_7.png`,
  calataganPot8: `${baseUrl}calatagan_pot_8.png`,
  calataganPot9: `${baseUrl}calatagan_pot_9.png`,
  calataganPot10: `${baseUrl}calatagan_pot_10.png`,
  calataganPot11: `${baseUrl}calatagan_pot_11.png`,
  calataganPot12: `${baseUrl}calatagan_pot_12.png`,
  calataganPot13: `${baseUrl}calatagan_pot_13.png`,
  calataganPot14: `${baseUrl}calatagan_pot_14.png`,
  calataganPot15: `${baseUrl}calatagan_pot_15.png`,
  calataganPot16: `${baseUrl}calatagan_pot_16.png`,
  homoSapiens: `${baseUrl}homo_sapiens.png`,
  buntonNgKabibe: `${baseUrl}bunton_ng_kabibe.png`,
  ngaNga: `${baseUrl}nganga.png`,
  vocabularioDeLenguaTagalaKabibe: `${baseUrl}vocabulario_de_lengua_tagala_kabibe.png`,
  tridacna: `${baseUrl}tridacna.png`,
  hippopus: `${baseUrl}hippopus.png`,
  adductorMuscles: `${baseUrl}adductor_muscles.png`,
  povedanoCalendar: `${baseUrl}povedano_calendar.png`,
  viennaCodex: `${baseUrl}vienna_codex.png`,
  sinupuanNgWikangTagalog: `${baseUrl}sinupuan_ng_wikang_tagalog.png`,
  povedanoCalendarDetails: `${baseUrl}povedano_calendar_details.png`,
  sinaunangAraw: `${baseUrl}sinaunang_araw.png`,
  bulilang: `${baseUrl}bulilang.png`,
  basehanNgBulilang: `${baseUrl}basehan_ng_bulilang.png`,
  bulilangTaklobo: `${baseUrl}bulilang_taklobo.png`,
  unangLibroBata: `${baseUrl}unang_libro_bata.png`,
  unangLibroUha1: `${baseUrl}unang_libro_uha_1.png`,
  unangLibroUha2: `${baseUrl}unang_libro_uha_2.png`,
  comintang: `${baseUrl}comintang.png`,
}

const aboutBaseUrl = "/assets/images/about_us_images/"

export const AwangganImages = {
  awanngan1: `${aboutBaseUrl}awanggan_1.jpg`,
  awanngan2: `${aboutBaseUrl}awanggan_2.jpg`,
  awanngan3: `${aboutBaseUrl}awanggan_3.jpg`,
  awanngan4: `${aboutBaseUrl}awanggan_4.jpg`,
  awanngan5: `${aboutBaseUrl}awanggan_5.jpg`,
}